import { render, staticRenderFns } from "./TheSurveys.vue?vue&type=template&id=18e6b118&"
import script from "./TheSurveys.vue?vue&type=script&lang=js&"
export * from "./TheSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports